export default __webpack_public_path__ + "static/media/camera.907b4645.svg";